import { useContext } from 'react';
import { TimezoneContext } from '../provider/TimezoneProvider';

function useTimezone() {
  return useContext(TimezoneContext);
}

export default useTimezone;
